import { combineReducers } from "redux";

import commonReducer, { CommonState } from "./common";
import showReducer, { ShowState } from "./show";
import aboutReducer, { AboutState } from "./about";
import membersReducer, { MembersState } from "./members";
import postsReducer, { PostsState } from "./posts";
import projectsReducer, { ProjectsState } from "./projects";

export interface CompaniesState {
  common: CommonState;
  show: ShowState;
  about: AboutState;
  members: MembersState;
  posts: PostsState;
  projects: ProjectsState;
}

export const reducer = combineReducers({
  common: commonReducer,
  show: showReducer,
  about: aboutReducer,
  members: membersReducer,
  posts: postsReducer,
  projects: projectsReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/index.ts